<div class="container">
    <rr-start-logo class="logo" color="inverse" routerLink="/"></rr-start-logo>

    <div class="card-wrapper">
        @if (companyData) {
            <div class="company-logo align-center row">
                <div class="align-center row">
                    <app-company-logo
                        [company]="companyData"
                    ></app-company-logo>

                    <h1>{{ companyData.name }}</h1>
                </div>
            </div>
        }

        <rr-card *ngIf="registrySuccess == true">
            @if (registerForm) {
                <rr-card-content>
                    <form
                        class="registerform"
                        [formGroup]="registerForm"
                        (ngSubmit)="onSubmit()"
                    >
                        <div class="col headline" *ngIf="!companyData">
                            <h1 i18n>Sign up for free</h1>
                            <span i18n>Free Trial</span>
                            <!-- <span i18n>No credit card required</span> -->
                        </div>
                        <div class="col headline" *ngIf="companyData">
                            <h1 i18n>
                                Sign up to {{ companyData.name }}'s environment
                            </h1>
                        </div>
                        @if (activeCustomFields.length) {
                            @for (field of activeCustomFields; track field.id) {
                                <rr-input
                                    [label]="fieldLabel(field.id)"
                                    [type]="field.type"
                                    [required]="field.required"
                                    [verifyPassword]="field.type === 'password'"
                                    [formControlName]="field.id"
                                ></rr-input>
                            }
                        } @else {
                            <rr-input
                                label="Email"
                                [required]="true"
                                type="email"
                                formControlName="email"
                            ></rr-input>
                            <rr-input
                                label="Password"
                                type="password"
                                [required]="true"
                                [verifyPassword]="true"
                                formControlName="password"
                            ></rr-input>
                            @if (!companyData) {
                                <rr-input
                                    label="Your Company Name"
                                    type="text"
                                    [required]="true"
                                    formControlName="companyName"
                                ></rr-input>
                            }
                        }

                        <rr-btn type="Primary" (btnClick)="onSubmit()" i18n
                            >Sign up</rr-btn
                        >
                        <div class="row gap-8 tiny">
                            <span i18n>Already have an account?</span>
                            <a i18n href="/login">Log in</a>
                        </div>
                    </form>
                </rr-card-content>
            }
            <rr-card-footer>
                <!-- <span class="tiny" i18n -->
                <!--     >By signing up you agree to our -->
                <!--     <a href="/terms">terms of service</a></span -->
                <!-- > -->
                <rr-disclaimer
                    [type]="disclaimerType"
                    [showIcon]="false"
                ></rr-disclaimer>
            </rr-card-footer>
        </rr-card>
        <h1 *ngIf="registrySuccess === false && regError === false">
            Registration successful
        </h1>
        <h1 *ngIf="regError == true">Registration not successful!</h1>
        <rr-spinner *ngIf="!hidespinner"></rr-spinner>
        <input type="phone" name="phone" id="phone" [(ngModel)]="phone" />
    </div>
</div>
